import { useMemo, useRef, useState } from 'react';
import { ColDef } from 'ag-grid-enterprise';
import { useClipboard } from '@mantine/hooks';
import { notifications } from '@mantine/notifications';
import { useApi } from '@/src/composables/useApi';
import { IMarketplaceService } from '@/src/models/marketplace-service';
import { IGridRef } from '@/src/shared/components/shared/GridComponent';
import { RoutesApi } from '@/src/shared/constants/route';
import { useOutletStore } from '@/src/stores/OutletStore';

const useModuleOutlet = () => {
  const outletStore = useOutletStore();
  const clipboard = useClipboard({ timeout: 500 });

  const outlet = useMemo(() => {
    return outletStore.dataOutlet;
  }, [outletStore.dataOutlet]);
  // const listService = useMemo(() => {
  //   return outletStore.dataOutlet?.list_service;
  // }, [outletStore.dataOutlet?.list_service]);
  // const listServiceRecommendation = useMemo(() => {
  //   return outletStore.dataOutlet?.service_recommendation;
  // }, [outletStore.dataOutlet?.service_recommendation]);

  const handleShare = async () => {
    let link = `${window.location.href}`;

    clipboard.copy(link);

    notifications.show({
      title: 'Berhasil',
      message: 'Link berhasil disalin',
    });
    // try {
    //     await navigator.share({
    //         title: outlet?.name,
    //         text: outlet?.address,
    //         url: link
    //     });
    // } catch (err) {
    //     console.error(err)
    // }
  };

  return {
    outlet,
    // listService,
    // listServiceRecommendation,
    handleShare,
  };
};

export default useModuleOutlet;
